module.exports = __webpack_public_path__ + "static/customer-experience-c5b13e02e527f100142cd65fa8cad9ee.jpg";